import { Box } from '@mui/material';
import classNames from 'classnames';
import React, { memo } from 'react';

import useScreenSize from '../../../util/hooks/useScreenSize';

const rootSx = (theme) => ({
  width: '100%',
  position: 'sticky',
  bottom: 0,
  zIndex: theme.tokens.zIndexTopbar,
  marginBottom: theme.tokens.BottomBar_height,
});

/**
 * This is a wrapper component for different Layouts.
 * TopBar should be added to this wrapper.
 * @param {object} props
 * @param {string | null} [props.className] - Additional class to be added to the root element.
 * @param {string | null} [props.rootClassName] - Additional class to be added to the root element.
 * @param {React.JSX.Element | React.JSX.Element[] | null} props.children - Collection of children to be rendered.
 * @returns {React.JSX.Element | null}
 */

const LayoutWrapperBottombarComponent = ({ className = null, rootClassName = null, children }) => {
  const classes = classNames(rootClassName, className);

  const { isDesktop } = useScreenSize();
  if (isDesktop) return null;

  return (
    <Box className={classes || undefined} sx={rootClassName ? undefined : rootSx}>
      {children}
    </Box>
  );
};

LayoutWrapperBottombarComponent.displayName = 'LayoutWrapperBottombar';

const LayoutWrapperBottombar = memo(LayoutWrapperBottombarComponent);

export default LayoutWrapperBottombar;
